import { z } from 'zod';

export const testimonialSchema = z.object({
  name: z.string(),
  profession: z.string(),
  quote: z.string(),
  /**
   * Absolute path to a 144x144 headshot under `public/images`, or an empty
   * string when the graduate supplied no usable photo. Empty falls back to the
   * initials avatar, so callers must coerce it to `undefined` rather than
   * passing it straight to an `img` src.
   */
  headshot: z.string(),
  /**
   * `YYYY-MM-DD` the testimonial was collected, or an empty string for the
   * graduates the survey export left blank. The card keeps these out of the UI
   * until the export is complete, so nothing renders a date today — see
   * `SHOW_TESTIMONIAL_DATE` in `components/graduate-testimonials-subsection.tsx`.
   */
  date: z.string(),
});

/**
 * The carousel renders each program's entries in data order, and nothing sorts
 * at runtime, so keep graduates with a `headshot` ahead of those without when
 * editing the data file.
 */
export const testimonialsByProgramKeySchema = z.record(z.array(testimonialSchema));

export type Testimonial = z.infer<typeof testimonialSchema>;
export type TestimonialsByProgramKey = z.infer<typeof testimonialsByProgramKeySchema>;
